/**
 * Shared ReactMarkdown components configuration
 * Ensures consistent markdown rendering across the application
 */
export const getMarkdownComponents = () => ({
  ol: ({ children }) => (
    <ol className="list-decimal list-inside space-y-1 mb-4">{children}</ol>
  ),
  ul: ({ children }) => (
    <ul className="list-disc list-inside space-y-1 mb-4">{children}</ul>
  ),
  li: ({ children }) => <li className="ml-4">{children}</li>,
  strong: ({ children }) => (
    <strong className="font-bold text-gray-900">{children}</strong>
  ),
  p: ({ children }) => <p className="mb-4">{children}</p>,
});

/**
 * Renders markdown content with consistent styling
 * @param {string} content - The markdown content to render
 * @param {object} additionalComponents - Additional components to merge with defaults
 * @returns {JSX.Element} - Rendered ReactMarkdown component
 */
export const renderMarkdown = (content, additionalComponents = {}) => {
  const components = {
    ...getMarkdownComponents(),
    ...additionalComponents,
  };

  return { components };
};
